import { CreateCategory } from '@app/pages/b2b/QuestionsLibrary/components';
import { CategoryType } from '@data/sdk/match';
import { ClassificationTable } from '../components';
import { useQuestionClassification } from '../hooks';

const QuestionStarters = () => {
  const {
    current,
    pageSize,
    isLoading,
    categories,
    isCreateCategoryOpen,
    handleTableChange,
    openCreateCategory,
    closeCreateCategory,
    questionId,
  } = useQuestionClassification(CategoryType.Starter);

  return (
    <>
      <ClassificationTable
        type={CategoryType.Starter}
        createCategory
        current={current}
        pageSize={pageSize}
        isLoading={isLoading}
        total={categories?.count || 0}
        categories={categories?.items}
        handleTableChange={handleTableChange}
        openCreateCategory={openCreateCategory}
      />

      <CreateCategory
        open={isCreateCategoryOpen}
        close={closeCreateCategory}
        questionId={questionId}
        type={CategoryType.Starter}
      />
    </>
  );
};

export default QuestionStarters;
